export const DEFAULT_ELASTIC_FIELDS = [
  'description',
  'title',
  'image',
  'tax_topic',
  'tax_industry',
  'publication_date',
  'release_date',
  'read_time',
  'url',
  'tax_content_category',
  'podcast_series',
  'language',
];
